import { ClientIntegrationType } from "~/operations";
import {
  ActiveScope,
  OrganizationScope,
  ScopeType,
  SpaceScope,
} from "~/hooks/useScope";
import { mapIntegrationType } from "~/lib/integrations";

export const integrationDetailHref = (
  type: ClientIntegrationType,
  mrn: string,
  scope: SpaceScope | OrganizationScope,
) => {
  const id = mrn.split("/").pop();
  return `/${scope.type === ScopeType.Space ? "space" : "organization"}/integrations/${encodeURIComponent(mapIntegrationType(type))}/${id}?${scope.params}`;
};

type GetIntegrationAddHrefParams = {
  scope: SpaceScope | OrganizationScope;
  integrationTypeId: string;
  namespace?: string;
};

export const getIntegrationAddHref = ({
  scope,
  integrationTypeId,
}: GetIntegrationAddHrefParams) => {
  if (scope.type === ScopeType.Space) {
    return `/space/integrations/add/${integrationTypeId}?${scope.params}`;
  }

  return `/organization/integrations/security_pipeline_github/add/setup?${scope.params}`;
};

type GetAvailableIntegrationAddHrefParams = {
  scope: ActiveScope;
};

export const getAvailableIntegrationAddHref = ({
  scope,
}: GetAvailableIntegrationAddHrefParams) => {
  if (scope.type === ScopeType.Space) {
    return `/space/integrations/add?${scope.params}`;
  }

  return `/organization/integrations/security_pipeline_github?${scope.params}`;
};

type GetIntegrationsListHrefParams = {
  scope: ActiveScope;
  integrationTypeId?: string;
};

export const getIntegrationsListHref = ({
  scope,
  integrationTypeId,
}: GetIntegrationsListHrefParams) => {
  if (scope.type === ScopeType.Space) {
    return `/space/integrations${integrationTypeId ? `/${integrationTypeId}/` : ""}?${scope.params}`;
  }

  return `/organization/integrations/security_pipeline_github?${scope.params}`;
};

type GetIntegrationMrn = {
  scope: ActiveScope;
  integrationId: string | undefined;
};

export const getIntegrationMrn = ({
  scope,
  integrationId,
}: GetIntegrationMrn) => {
  if (!integrationId) return getAvailableIntegrationAddHref({ scope });

  return scope.type === ScopeType.Space
    ? `//integration.api.mondoo.app/spaces/${scope.id}/integrations/${integrationId}`
    : `//integration.api.mondoo.app/organizations/${scope.id}/integrations/${integrationId}`;
};
